import React from "react";

// const InternShipDetails = () => {
//   return(

//   <div>
//     <div>
//       <p className="internshipTitle">1st Intership</p>
//       <div style={{ margin: "5px 0px" }}>
//         <div className="StdAlertBoxCardTextDiv">
//           <label style={{ fontWeight: "bold", width: "45%" }}>
//             Period of internship
//           </label>
//           <p style={{ fontWeight: "bold", width: "2px" }}>:</p>
//           <p style={{ width: "55%" }}>2 Year 2 Semester</p>
//         </div>
//         <div className="StdAlertBoxCardTextDiv">
//           <label style={{ fontWeight: "bold", width: "45%" }}>
//             Report submission
//           </label>
//           <p style={{ fontWeight: "bold", width: "2px" }}>:</p>
//           <p style={{ width: "55%" }}>3 Year 1 Semester</p>
//         </div>
//       </div>
//     </div>
//     <div>
//       <p className="internshipTitle">2nd Intership</p>
//       <div style={{ margin: "5px 0px" }}>
//         <div className="StdAlertBoxCardTextDiv">
//           <label style={{ fontWeight: "bold", width: "45%" }}>
//             Period of internship
//           </label>
//           <p style={{ fontWeight: "bold", width: "2px" }}>:</p>
//           <p style={{ width: "55%" }}>3 Year 2 Semester</p>
//         </div>
//         <div className="StdAlertBoxCardTextDiv">
//           <label style={{ fontWeight: "bold", width: "45%" }}>
//             Report submission
//           </label>
//           <p style={{ fontWeight: "bold", width: "2px" }}>:</p>
//           <p style={{ width: "55%" }}>4 Year 1 Semester</p>
//         </div>
//       </div>
//     </div>
//   </div>
//   )
// };

const StdAlertBox = () => {
  return (
    <div className="StdAlertBox">
      {/* <p className="StdAlertBoxTitle">When Intership have to do ?</p> */}
      <div className="StdAlertBoxCardDiv">
        <div className="">
          <div>
            <p className="StdAlertBoxCardTitle">For every B.Tech student Now it's mandatory to do Internships & projects!!</p>
          </div>
        </div>
        <div className="datesBox">
          <div className="StdAlertBoxCard">
            <div style={{ margin: "5px 0px" }}>
              <p className="internshipTitle">1st Intership</p>
              <div className="StdAlertBoxCardTextDiv">
                <label style={{ fontWeight: "bold", width: "45%" }}>
                  Period of internship
                </label>
                <p style={{ fontWeight: "bold", width: "2px" }}>:</p>
                <p style={{ width: "55%" }}>2 Year 2 Semester</p>
              </div>
              <div className="StdAlertBoxCardTextDiv">
                <label style={{ fontWeight: "bold", width: "45%" }}>
                  Report submission
                </label>
                <p style={{ fontWeight: "bold", width: "2px" }}>:</p>
                <p style={{ width: "55%" }}>3 Year 1 Semester</p>
              </div>
            </div>
            <div style={{ margin: "5px 0px" }}>
              <p className="internshipTitle">2nd Intership</p>
              <div className="StdAlertBoxCardTextDiv">
                <label style={{ fontWeight: "bold", width: "45%" }}>
                  Period of internship
                </label>
                <p style={{ fontWeight: "bold", width: "2px" }}>:</p>
                <p style={{ width: "55%" }}>3 Year 2 Semester</p>
              </div>
              <div className="StdAlertBoxCardTextDiv">
                <label style={{ fontWeight: "bold", width: "45%" }}>
                  Report submission
                </label>
                <p style={{ fontWeight: "bold", width: "2px" }}>:</p>
                <p style={{ width: "55%" }}>4 Year 1 Semester</p>
              </div>
            </div>
          </div>
          <div className="StdAlertBoxCard">
            <div>
              <div style={{ margin: "5px 0px" }}>
                <p className="internshipTitle">Final Year </p>
                <div className="StdAlertBoxCardTextDiv">
                  <label style={{ fontWeight: "bold", width: "45%" }}>
                    Period of internship
                  </label>
                  <p style={{ fontWeight: "bold", width: "2px" }}>:</p>
                  <p style={{ width: "55%" }}>4 Year 2 Semester</p>
                </div>
                <div className="StdAlertBoxCardTextDiv">
                  <label style={{ fontWeight: "bold", width: "45%" }}>
                    Report submission
                  </label>
                  <p style={{ fontWeight: "bold", width: "2px" }}>:</p>
                  <p style={{ width: "55%" }}>4 Year 2 Semester</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div>
          <p className="internshipTitle">2nd Intership</p>
          <div style={{ margin: "5px 0px" }}>
            <div className="StdAlertBoxCardTextDiv">
              <label style={{ fontWeight: "bold", width: "45%" }}>
                Period of internship
              </label>
              <p style={{ fontWeight: "bold", width: "2px" }}>:</p>
              <p style={{ width: "55%" }}>2 Year 2 Semester</p>
            </div>
            <div className="StdAlertBoxCardTextDiv">
              <label style={{ fontWeight: "bold", width: "45%" }}>
                Report submission
              </label>
              <p style={{ fontWeight: "bold", width: "2px" }}>:</p>
              <p style={{ width: "55%" }}>20-3-2022 To 20-5-2022</p>
            </div>
          </div>
        </div> */}
        {/* <div className="StdAlertBoxCard">
          <p className="StdAlertBoxCardTitle">2020-24 Batch</p>
          <div>
            <p className="internshipTitle">1st Intership</p>
            <div style={{ margin: "5px 0px" }}>
              <div className="StdAlertBoxCardTextDiv">
                <label style={{ fontWeight: "bold", width: "45%" }}>
                  Period of internship
                </label>
                <p style={{ fontWeight: "bold", width: "2px" }}>:</p>
                <p style={{ width: "55%" }}>2 Year 2 Semester</p>
              </div>
              <div className="StdAlertBoxCardTextDiv">
                <label style={{ fontWeight: "bold", width: "45%" }}>
                  Report submission
                </label>
                <p style={{ fontWeight: "bold", width: "2px" }}>:</p>
                <p style={{ width: "55%" }}>20-3-2022 To 20-5-2022</p>
              </div>
            </div>
          </div>
          <div>
            <p className="internshipTitle">2nd Intership</p>
            <div style={{ margin: "5px 0px" }}>
              <div className="StdAlertBoxCardTextDiv">
                <label style={{ fontWeight: "bold", width: "45%" }}>
                  Period of internship
                </label>
                <p style={{ fontWeight: "bold", width: "2px" }}>:</p>
                <p style={{ width: "55%" }}>2 Year 2 Semester</p>
              </div>
              <div className="StdAlertBoxCardTextDiv">
                <label style={{ fontWeight: "bold", width: "45%" }}>
                  Report submission
                </label>
                <p style={{ fontWeight: "bold", width: "2px" }}>:</p>
                <p style={{ width: "55%" }}>20-3-2022 To 20-5-2022</p>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default StdAlertBox;
